import {Component, OnInit, ViewChild} from '@angular/core';



@Component({
    selector: 'app-dmn',
    templateUrl: './dmn.component.html',
    styleUrls: ['./dmn.component.scss']
})
export class DmnComponent implements OnInit {
    ngOnInit() {
    }

}
